import Swal from 'sweetalert2';
import 'jquery-validation';

var locale = $("body").data('lang');

document.addEventListener("DOMContentLoaded", function () {
  loadContent();

  if(locale == 'en'){
    var recaptcha_error ="Recaptcha is needed"
  }else{
    var recaptcha_error="Sila tanda Recaptcha"
  }

  $("#new_volunteer_form").validate({
    rules: {
      'volunteer[name]': { required: true },
      'volunteer[display_name]': { required: true },
      'volunteer[email]': {
        required: true,
        email: true
      },
      'volunteer[phone]': { required: true },
      'volunteer[jobs]': { required: true },
    },
    errorPlacement: function (error, element) {
      error.addClass('invalid-feedback');
      element.closest('.form-group').append(error);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('is-invalid');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('is-invalid');
    },
    submitHandler: function () {
      var url = $("#new_volunteer_form").attr('action');

      $.ajax({
        type: "POST",
        url: url,
        data: $("#new_volunteer_form").serialize(),
        dataType: "json",
        success: function(data)
        {
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: data["message"]
          })
        },
        error: function (xhr, ajaxOptions, thrownError) {
          var elem = document.createElement('div');
          console.log(xhr.responseText);
          if(xhr.responseText=="{}"){
            Swal.fire({
              icon: 'error',
              title: 'Chup!',
              text: recaptcha_error
            })
          }else{
            $.each(xhr.responseJSON, function( index, value ) {
              elem.append(index[0].toUpperCase() + index.slice(1) + " " +value);
            });
            Swal.fire({
              icon: 'error',
              title: 'Chup!',
              html: elem
            })
          }
        }
      });
    },
  });
});


function loadContent() {
  var url=""
  if(locale == 'en'){
    url="https://blog.mymp.org.my/wp-json/wp/v2/pages/217"
  }else{
    url="https://blog.mymp.org.my/wp-json/wp/v2/pages/232"
  }

  var xhr = $.getJSON(url, function (data) {

    $("#volunteer-title").html(data.title.rendered);
    $("#volunteer-content").html(data.content.rendered);

  });
}